/* eslint-disable react/jsx-no-undef */
import React from "react";
// import { Tabs } from "antd";
import Heading from "../../components/Heading";
import "./style.scss";
import DRSList from "./DRSList";

const DRS = () => {
  return (
    <div className="p-1">
      <Heading title="DRS" navigateTo="/dashboard" />
      <div className="global-card-tab-container">
        <DRSList />
      </div>
    </div>
  );
};

export default DRS; 
